module.exports = __webpack_public_path__ + "media/conmex/legislacion-36601802.png";